import axios from "axios";
//import fileDownload from "js-file-download";
const CONTROLLER_PATH = "Report";
class ReportService {
    patientList(fromDate, toDate) {
        return this.getFromToReport("/PatientList", { fromDate, toDate });
    }
    acceptedLog(fromDate, toDate) {
        return this.getFromToReport("/AcceptedLog", { fromDate, toDate });
    }
    incidentException() {
        return this.getFromToReport("/IncidentException");
    }
    patientException() {
        return this.getFromToReport("/PatientException");
    }
    accountException() {
        return this.getFromToReport("/AccountException");
    }
    claimException() {
        return this.getFromToReport("/ClaimException");
    }
    newaccountregistrationsreport(fromDate, toDate) {
        return this.getFromToReport("/newaccountregistrationsreport", { fromDate, toDate });
    }
    verifiedaccountsreport(fromDate, toDate) {
        return this.getFromToReport("/verifiedaccountsreport", { fromDate, toDate });
    }
    queriedaccountsreport(fromDate, toDate) {
        return this.getFromToReport("/queriedaccountsreport", { fromDate, toDate });
    }
    queriedaccountspdfreport(params) {
        return this.getFromToReport("/queriedaccountspdfreport", params);
    }
    rejectedaccountspdfreport(params) {
        return this.getFromToReport("/rejectedaccountspdfreport", params);
    }
    paidaccountspdfreport(params) {
        return this.getFromToReport("/paidaccountspdfreport", params);
    }
    acceptedaccountspdfreport(params) {
        return this.getFromToReport("/acceptedaccountspdfreport", params);
    }
    partlyacceptedaccountspdfreport(params) {
        return this.getFromToReport("/partlyacceptedaccountspdfreport", params);
    }
    newaccountspdfreport(params) {
        return this.getFromToReport("/newaccountspdfreport", params);
    }
    acceptedaccountsreport(fromDate, toDate) {
        return this.getFromToReport("/acceptedaccountsreport", { fromDate, toDate });
    }
    rejectedaccountsreport(fromDate, toDate) {
        return this.getFromToReport("/rejectedaccountsreport", { fromDate, toDate });
    }
    processedaccountsreport(fromDate, toDate) {
        return this.getFromToReport("/processedaccountsreport", { fromDate, toDate });
    }
    partlyacceptedaccountsreport(fromDate, toDate) {
        return this.getFromToReport("/partlyacceptedaccountsreport", { fromDate, toDate });
    }
    arsuspendedincidentsreport(fromDate, toDate) {
        return this.getFromToReport("/arsuspendedincidentsreport", { fromDate, toDate });
    }
    lateregistrationsuspendedincidentsreport(fromDate, toDate) {
        return this.getFromToReport("/lateregistrationsuspendedincidentsreport", { fromDate, toDate });
    }
    missingdocumentssuspendedpatientsreport(fromDate, toDate) {
        return this.getFromToReport("/missingdocumentssuspendedpatientsreport", { fromDate, toDate });
    }
    accountsstatusreport(params) {
        return this.getFromToReport("/accountsstatusreport", params);
    }
    getpatientlog(params) {
        return this.getFromToReport("/getpatientlog", params);
    }
    getincidentlog(params) {
        return this.getFromToReport("/getincidentlog", params);
    }

    
    rejectedaccountsreportlive(params) {
        return this.getFromToReport("/rejectedaccountsreportlive", params);
    }
        acceptedaccountsreportlive(params) {
        return this.getFromToReport("/acceptedaccountsreportlive", params);
    }
        partlyacceptedaccountsreportlive(params) {
        return this.getFromToReport("/partlyacceptedaccountsreportlive", params);
    }
        verifiedaccountsreportlive(params) {
        return this.getFromToReport("/verifiedaccountsreportlive", params);
    }
        queriedaccountsreportlive(params) {
        return this.getFromToReport("/queriedaccountsreportlive", params);
    }
        processedaccountsreportlive(params) {
        return this.getFromToReport("/processedaccountsreportlive", params);
    }
    newaccountsreportlive(params) {
        return this.getFromToReport("/newaccountsreportlive", params);
    }

    acceptednotyetsubmittedclaimsreportlive(params) {
        return this.getFromToReport("/acceptednotyetsubmittedclaimsreportlive", params);
    }

    getFromToReport(reportPath, parametersObject) {
        return axios.get(CONTROLLER_PATH + reportPath, {
            params: parametersObject ?? {},
            responseType: "blob",
            timeout: 0,
        });
        /*
      .then(function(response) {
        fileDownload(
          response.data,
          response.headers["content-disposition"].match(
            /filename\s*=\s*(.+);/i
          )[1]
        );
      });
      */
    }
}

export default new ReportService();
